import { TextareaAutosize } from '@mui/material';
import styled from 'styled-components';
import { BackgroundColor, BorderColor, TextColor } from './colorSemantic';
import { Radius } from './objectStyles';
import { font, palette } from './globalStyles';
import { Body3Medium } from 'styles/Global/typography';

export const DCKTextArea = styled(TextareaAutosize)`
    display: flex;
    align-items: flex-start;
    width: 100%;
    // height: 108px;
    padding: 18px 20px;
    border: 1px solid ${BorderColor.color_border_normal};
    border-radius: ${Radius.radius_4};
    font-size: ${font.size[16]};
    font-weight: ${font.weight.medium};
    line-height: 24px;
    resize: none;
    outline: none;

    &:focus :hover {
        background-color: ${palette.white};
    }

    &:hover {
        border: 1px solid ${BorderColor.color_border_normal_hover};
    }

    &:disabled {
        border: 1px solid ${BorderColor.color_border_normal};
        background-color: ${BackgroundColor.color_background_disabled};
        color: ${TextColor.color_text_normal};

        &:hover {
            background-color: inherit;
        }
    }

    &:focus {
        border: 1px solid ${BorderColor.color_border_normal_press};
    }
    &::placeholder {
        color: ${TextColor.color_text_placeholder};
    }
`;

export const CLMessageTextArea = styled(TextareaAutosize)`
    display: flex;
    align-items: flex-start;
    width: 100%;
    // height: 108px;
    font-size: ${font.size[16]};
    font-weight: ${font.weight.medium};
    line-height: 24px;
    resize: none;
    outline: none;
`;
